// extracted by mini-css-extract-plugin
export var closeButton = "_x-0";